var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Shevron_Down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.414,
    height: 7.414,
    viewBox: "0 0 13.414 7.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Shevron_Down .cls-1 {\n        fill: none;\n        stroke: #f5f5f5;\n        stroke-linecap: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfd_Shevron_Down",
    "data-name": "Shevron Down",
    className: "cls-1",
    d: "M240,592l6,6,6-6",
    transform: "translate(-239.293 -591.293)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ac960e99cca1b4e9b7813dc87fc7f6dd.svg";
export { ForwardRef as ReactComponent };